import { useQuery } from "@grandvisionhq/graphql";
import { useIntl } from "@grandvisionhq/state";
import { dispatchTrackErrorEvent } from "@grandvisionhq/svc-tealium/events";
import { isArray } from "@grandvisionhq/utils";
import { mapDeliveryEstimation } from "../../mappers/mappers/delivery-estimation.js";
import { GET_DELIVERY_ESTIMATION } from "../../operations/queries/operations/queries/get-delivery-estimation.js";
const useGetDeliveryEstimationMessage = (items, shippingMethodKey, hasRxLens = false) => {
  const {
    dateTime: { formatDate },
    getFormattedLabel,
    locale,
    getLabel
  } = useIntl();
  const { data, loading, error } = useQuery(
    GET_DELIVERY_ESTIMATION,
    {
      variables: {
        input: {
          skuQuantityPairs: items,
          shippingMethodKey
        }
      }
    }
  );
  const deliveryEstimation = mapDeliveryEstimation(data, locale);
  let deliveryMessage = "";
  if (deliveryEstimation?.deliveryDate) {
    deliveryMessage = getFormattedLabel("products.deliveryIndicator.deliveryIndicationFullDate", {
      labelData: {
        deliveryDate: formatDate(deliveryEstimation.deliveryDate, "short"),
        deliveryMethod: deliveryEstimation.shippingMethodDescription
      }
    });
  } else if (hasRxLens && deliveryEstimation?.deliveryRanges?.minWithPrescription && deliveryEstimation?.deliveryRanges?.maxWithPrescription) {
    deliveryMessage = getFormattedLabel("products.deliveryIndicator.deliveryIndicationRanges", {
      labelData: {
        deliveryMin: deliveryEstimation.deliveryRanges.minWithPrescription,
        deliveryMax: deliveryEstimation.deliveryRanges.maxWithPrescription,
        deliveryMethod: deliveryEstimation.shippingMethodDescription
      }
    });
  } else if (deliveryEstimation?.deliveryRanges?.min && deliveryEstimation?.deliveryRanges?.max) {
    deliveryMessage = getFormattedLabel("products.deliveryIndicator.deliveryIndicationRanges", {
      labelData: {
        deliveryMin: deliveryEstimation.deliveryRanges.min,
        deliveryMax: deliveryEstimation.deliveryRanges.max,
        deliveryMethod: deliveryEstimation.shippingMethodDescription
      }
    });
  }
  if (error) {
    console.error(error);
    dispatchTrackErrorEvent(
      () => Promise.resolve({
        Error_Source: "Server",
        Error_Code: "Pdp",
        Error_Details: isArray(error.graphQLErrors) ? error.graphQLErrors.map((error2) => error2.message).join(",") : error.message,
        Error_Message: getLabel("products.deliveryIndicator.fallbackMessage")
      })
    );
  }
  return { deliveryMessage, loading, error };
};
export {
  useGetDeliveryEstimationMessage
};
//# sourceMappingURL=use-get-delivery-estimation-message.js.map
